export const STANDALONE_SECTION_TYPES = [
  "APP_PANEL",
  "BENEFITS_STRIP",
  "BENTO_GRID",
  "BLUE_PRODUCT_RAIL",
  "BRAND_LOGOS",
  "BRAND_SPOTLIGHT",
  "CATEGORY_CUTOUTS",
  "CATEGORY_HERO",
  "CATEGORY_PHOTOS",
  "CATEGORY_TILES",
  "COLLECTION_BANNERS",
  "COMPACT_PRODUCT_RAIL",
  "COUNTDOWN_BANNER",
  "CTA_PANEL",
  "CUSTOMER_STORIES",
  "FAQ",
  "IMAGE_BANNERS",
  "LOOK_CARD",
  "OUTFIT_ROW",
  "PAYMENT_EXAMPLE",
  "PHOTO_BANNER",
  "PHOTO_HERO",
  "PHOTO_WALL",
  "PLAIN_PRODUCT_RAIL",
  "PRICE_SHORTCUTS",
  "PRODUCT_RAIL",
  "PRODUCT_SPOTLIGHT",
  "PROMO_CARDS",
  "SPLIT_HERO",
  "STAT_WALL",
  "TRUST_PANEL",
] as const
export const STANDALONE_SECTION_RULES = [
  { type: "APP_PANEL", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "BENEFITS_STRIP", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "BENTO_GRID", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "BLUE_PRODUCT_RAIL", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["PRODUCTS", "SAVED_PRODUCTS"] },
  { type: "BRAND_LOGOS", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC", "CATEGORIES", "COLLECTIONS"] },
  { type: "BRAND_SPOTLIGHT", authorable: true, minItems: 3, maxLimit: 100, acceptedSources: ["PRODUCTS", "SAVED_PRODUCTS"] },
  { type: "CATEGORY_CUTOUTS", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC", "CATEGORIES", "COLLECTIONS"] },
  { type: "CATEGORY_HERO", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "CATEGORY_PHOTOS", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC", "CATEGORIES", "COLLECTIONS"] },
  { type: "CATEGORY_TILES", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC", "CATEGORIES", "COLLECTIONS"] },
  { type: "COLLECTION_BANNERS", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC", "CATEGORIES", "COLLECTIONS"] },
  { type: "COMPACT_PRODUCT_RAIL", authorable: true, minItems: 4, maxLimit: 100, acceptedSources: ["PRODUCTS", "SAVED_PRODUCTS"] },
  { type: "COUNTDOWN_BANNER", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "CTA_PANEL", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "CUSTOMER_STORIES", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "FAQ", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "IMAGE_BANNERS", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC", "CATEGORIES", "COLLECTIONS"] },
  { type: "LOOK_CARD", authorable: true, minItems: 3, maxLimit: 100, acceptedSources: ["PRODUCTS", "SAVED_PRODUCTS"] },
  { type: "OUTFIT_ROW", authorable: true, minItems: 3, maxLimit: 100, acceptedSources: ["GROUPED_PRODUCTS"] },
  { type: "PAYMENT_EXAMPLE", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "PHOTO_BANNER", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "PHOTO_HERO", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "PHOTO_WALL", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "PLAIN_PRODUCT_RAIL", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["PRODUCTS", "SAVED_PRODUCTS"] },
  { type: "PRICE_SHORTCUTS", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "PRODUCT_RAIL", authorable: true, minItems: 4, maxLimit: 100, acceptedSources: ["PRODUCTS", "SAVED_PRODUCTS"] },
  { type: "PRODUCT_SPOTLIGHT", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["PRODUCTS", "SAVED_PRODUCTS"] },
  { type: "PROMO_CARDS", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC", "CATEGORIES", "COLLECTIONS"] },
  { type: "SPLIT_HERO", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "STAT_WALL", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
  { type: "TRUST_PANEL", authorable: true, minItems: 1, maxLimit: 100, acceptedSources: ["STATIC"] },
] as const
